import type { Picture as PictureType } from '@/@types/common'
import { css } from '@emotion/react'
import { ImageIcon } from '@ruguoapp/jike-fe-icons'
import type { HTMLAttributes } from 'react'
import { Gallery, Item } from 'react-photoswipe-gallery'

export interface ViewPictureTextProps extends HTMLAttributes<HTMLDivElement> {
	data: PictureType
}

export default function ViewPictureText({ data, ...props }: ViewPictureTextProps) {
	return (
		<Gallery>
			<Item
				key={data.key}
				thumbnail={data.thumbnailUrl}
				original={data.picUrl}
				width={data.width}
				height={data.height}
			>
				{({ ref, open }) => (
					<div
						{...props}
						ref={ref}
						css={css`
							display: inline-flex;
							gap: 0.25rem;
							align-items: center;
							color: var(--tint-jike-blue, #009be0);
							line-height: inherit;
							white-space: nowrap;
							vertical-align: text-bottom;
						`}
						onClick={(e) => {
							e.stopPropagation()
							open(e)
							// handlePreview([convertPictureToGalleryItem(data)], 0)
						}}
					>
						<ImageIcon
							css={css`
								flex-shrink: 0;
								width: 1rem;
								height: 1rem;
								transform: translateY(1.5px);
							`}
						/>
						<span>查看图片</span>
					</div>
				)}
			</Item>
		</Gallery>
	)
}
